module.exports = __webpack_public_path__ + "img/France.d529b0ac.png";